export const BADGE_TYPE = {
  POWER_SIGN: "POWER_SIGN",
  LEARNING_TROPHY: "LEARNING_TROPHY",
  BIDIRECTIONAL_TROPHY: "BIDIRECTIONAL_TROPHY",
  INTERDISCIPLINARY_TROPHY: "INTERDISCIPLINARY_TROPHY",
} as const;

export type BadgeType = (typeof BADGE_TYPE)[keyof typeof BADGE_TYPE];

export const BADGE_FILTER_TYPE = {
  POWER_SIGN: "POWER_SIGN",
  LEARNING_TROPHIES: "!POWER_SIGN",
} as const;

export type BadgeFilterType = (typeof BADGE_FILTER_TYPE)[keyof typeof BADGE_FILTER_TYPE];
